module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	'use strict';

	/* load instantly exodentity */
	var __exodentityPromise = fox.exodentity.include().then(function () {
		__exodentityPromise = null;
	}).catch(function (e) {
		__exodentityPromise = null;

		console.error('Error while downloading exodentity script:', e);

		return true;
	});

	require('../../components/user-access')(fox);

	var _ = {
		injectGA: function () {
			var gaCodes = this.getOption('gaCodes');

			if (gaCodes) {
				fox.googleAnalytics.include();
				fox.googleAnalytics.setAccounts(gaCodes);
			}
		}
	};

	fox.registerWidget('SiteApp', {
		requireResources: function () {
			if (!__exodentityPromise)
				return fox.Promise.resolve(true);
			
			return __exodentityPromise;
		},

		configure: function () {
			var applyScripts = require('createElement.hook');
			
			this.registerOptions('', {
				'handleWom.ready': {
					'widget': '@this',
					'event': 'fox_ready',
					'callback': function() {
						setTimeout(applyScripts, 4000);
					}
				}
			});

			this.registerOptions('', {
				widgets: {
					permissionManager: {
						widget: 'PermissionManager',
						womPriority: 10
					}
				},
				handleWom: {
					onPermissionsUpdate: {
						widget: '#permissionManager',
						event: 'permissions_update',
						'params.checker': function (params) {
							return fox.intersection(['guest', 'member'], params).length;
						},
						callback: function (params) {
							var router = this.rwom1('#router');
							router.addRoutes(this.getOption('map.routes'));
							router.navigate(location.pathname.slice(1));
							this.wom('.Widget').forEach(function (widget) {
								return widget.render();
							});	
						}.bind(this)
					}
				}
			});

			if (__PROD__) {
				fox.each(document.querySelectorAll('img[_src]'), function(img) {
					img.setAttribute('src', fox._r(img.getAttribute('_src'), null, true));
					img.removeAttribute('_src');
				});
			}

			this.callParent('configure', arguments);
		},

		customInit: function () {
			this.callParent('customInit', arguments);

			var meta = fox.site.getEnv('public.metaData');

			if (this.getOption('widgets.permissionManager')) {
				this.setOption('$map', '@this:mapMember');
			}

			if (fox.isEmpty(meta)) {
				return;
			}

			fox.each(meta, function(data, page) {
				var page = page.replace('/', '');

				if (!page.length) {
					page = 'home';
				}

				if (page === 'store') {
					page = 'storeList';
				}

				var opts = this.getPageOptions(page) || {};

				opts.title = data.title;
				opts.description = data.description;
				opts.excludeTitlePrefix = true;
			}.bind(this));

		},

		init: function () {
			_.injectGA.call(this);

			var res = fox.dictionary && fox.dictionary._commit();

			this.callParent('init', arguments);
			this.registerOptions('~.Api', {
				'secure': fox.getEnv('ah') && [fox.getEnv('ah').split('').reverse().join(''), fox.getEnv('aet')]
			});
			this.registerOptions('~.Captcha', {
				'secure': fox.getEnv('ah') && [fox.getEnv('ah').split('').reverse().join(''), fox.getEnv('aet')]
			});

			if ('client' in this) {
				this.registerOptions('~.Widget', {
					'templateEnv.client': this.client
				});
			}

      this.registerOptions('.Socket', {
        'path': '',
      });
		},

		logout: function() {
			return this.rwom1('#logoutApi').psend().then(function(){
				fox.cookie.remove('user_auth');
			});
		},

		getPageOptions: function(page, map) {
			var currentMap = this.getOption('$map').split(':')[1];
			var widgets = this.getOption(currentMap.concat('.', 'widgets'));
			var result;

			fox.each(widgets, function(lauoytOptions, layout) {

				fox.each(lauoytOptions.widgets, function(pageOptions, pageAlias) {
					if (page === pageAlias) {
						result = pageOptions;
					}
				}.bind(this));

			}.bind(this));

			return result;
		}

	}, 'App');

})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/app/SiteApp.js
// module id = 812
// module chunks = 4